const appGlobal = {
  devicesId: '',
  isWebview: false,
};

export default appGlobal;
